<template>
  <svg
    t="1737111078051"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4948"
    width="48"
    height="48"
    :fill="fill"
  >
    <path 
      d="M870.1 1023.978h-95.8c-18.8 0-34.1-15.2-34.1-34.1s15.2-34.2 34.2-34.2h95.8c47.3 0 85.8-38.3 85.8-85.4v-716.4c0-47.3-38.2-85.7-85-85.7h-717.6c-46.8 0-85 38.2-85 85v717.5c0 46.8 38.4 85 85.7 85h318.6c18.8 0 34.1 15.2 34.1 34.1 0 18.8-15.2 34.1-34.1 34.1h-318.7c-84.8 0-154-68.8-154-153.2v-717.4c0-84.5 68.8-153.2 153.2-153.2h717.6c84.5 0 153.2 69 153.2 154v716.4c0.1 84.5-69 153.5-153.9 153.5zM780.9 277.378h-537.6c-18.8 0-34.1-15.2-34.1-34.1s15.2-34.1 34.1-34.1h537.6c18.8 0 34.1 15.2 34.1 34.1s-15.3 34.1-34.1 34.1zM780.9 516.278h-537.6c-18.8 0-34.1-15.2-34.1-34.1s15.2-34.1 34.1-34.1h537.6c18.8 0 34.1 15.2 34.1 34.1 0 18.8-15.3 34.1-34.1 34.1zM482.2 755.178h-238.9c-18.8 0-34.1-15.2-34.1-34.1 0-18.8 15.2-34.1 34.1-34.1h238.9c18.8 0 34.1 15.2 34.1 34.1 0 18.9-15.3 34.1-34.1 34.1z"
      p-id="4949"
      ></path>
  </svg>
</template>
<script>
export default {
  name: "BlueBackground",
  props: {
    fill: {
      default: "#ffffff"
    },
    width: {
      default: '40px'
    },
    height: {
      default: '40px'
    }
  },
};
</script>
